module.exports = __webpack_public_path__ + "static/media/no-view.d850de05.png";